import cx from 'classnames';
import { useMemo } from 'react';

import { ExpandableContent } from 'components';
import { formatUtils } from 'utils';

type Props = {
  text?: string;
  json?: any;
  maxLines?: number;
  maxLength?: number;
  indent?: number;
};

const MAX_LINES = 5;
const MAX_LENGTH = 100;
const DEFAULT_INDENT = 2;

export const ExpandedJson: React.FC<Props> = ({
  text,
  json,
  maxLines = MAX_LINES,
  maxLength = MAX_LENGTH,
  indent = DEFAULT_INDENT,
}) => {
  const { parsedText, lines, isJson } = useMemo(
    () => formatUtils.parseJsonText({ text, json }, indent),
    [text, json, indent],
  );

  const showToggleButton = useMemo(
    () => lines.length > maxLines,
    [lines.length, maxLines],
  );

  if (!text && !json) {
    return null;
  }

  if (isJson) {
    return (
      <ExpandableContent showToggleButton={showToggleButton}>
        {(isExpanded) => {
          const displayJson =
            !isExpanded && showToggleButton
              ? lines.slice(0, maxLines).join('\n') +
                '\n' +
                ' '.repeat(indent) +
                '...\n}'
              : parsedText;

          return displayJson ? <pre>{displayJson}</pre> : null;
        }}
      </ExpandableContent>
    );
  }

  return (
    <ExpandableContent showToggleButton={parsedText.length > maxLength}>
      {(isExpanded) => (
        <p className={cx({ 'tw-line-clamp-3': isExpanded })}>{parsedText}</p>
      )}
    </ExpandableContent>
  );
};
